/**
 * Created by staffanrantzow on 17/03/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import Utils from 'frilans-finans/utils/utils';
import { SalaryTypeConstants } from 'frilans-finans';

export class InvoiceActivityStatus extends React.Component {

  static propTypes = {
    invoice: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    containerStyle: PropTypes.string
  };

  getSteps () {
    const salaryPaid = this.getSalaryPaid();
    const invoicePaid = this.getInvoicePaid();

    let steps = [
      { type: 'salary', complete: salaryPaid, denied: false },
      { type: 'invoice', complete: invoicePaid, denied: false }
    ];

    if (this.isInvoicePaidBeforeSalary(invoicePaid, salaryPaid) ||
      this.isWaitingForPayment() && !salaryPaid) {
      steps = steps.reverse();
    }
    steps.unshift({
      type: 'approval',
      complete: (this.isWaitingForPayment() || this.isApproved()),
      denied: this.isNotApproved()
    });

    return steps;
  }

  getInvoicePaid () {
    const formattedDate = Utils.formatDate(this.props.invoice.fullPaymentDateTime);
    return formattedDate !== '-' ? formattedDate : 0;
  }

  getSalaryPaid () {
    const salaries = this.props.invoice.salaries;
    if (salaries.length) {
      const salary = salaries
        .find((salary) => salary.typeId === SalaryTypeConstants.REGULAR_TYPE && salary.userId === +this.props.user.id);
      if (salary) {
        const formattedDate = Utils.formatDate(salary.paidAt);

        return formattedDate !== '-' ? formattedDate : 0;
      }
    }
    return 0;
  }

  getSalaryPlannedPaymentAt () {
    const salaries = this.props.invoice.salaries;
    if (salaries.length) {
      const salary = salaries
        .find((salary) => salary.typeId === SalaryTypeConstants.REGULAR_TYPE && salary.userId === +this.props.user.id);
      if (salary) {
        const formattedDate = Utils.formatDate(salary.plannedPaymentAt);

        return formattedDate !== '-' ? formattedDate : 0;
      }
    }
    return null;
  }

  isInvoicePaidBeforeSalary (invoicePaid, salaryPaid) {
    if (isNaN(Date.parse(invoicePaid)) || invoicePaid === 0) {
      return false;
    }

    if (isNaN(Date.parse(salaryPaid)) || salaryPaid === 0) {
      return true;
    }

    return new Date(invoicePaid) < new Date(salaryPaid);
  }

  isAwaitingApproval () {
    return this.props.invoice.approvalStatus === 1;
  }

  isApproved () {
    return this.props.invoice.approvalStatus === 2;
  }

  isNotApproved () {
    return this.props.invoice.approvalStatus === 3;
  }

  isWaitingForPayment () {
    return this.props.invoice.approvalStatus === 4;
  }

  renderStepIcon (complete, denied = false) {
    if (denied) {
      return this.renderDeniedIcon();
    }

    if (complete) {
      return this.renderApprovedIcon();
    }

    return this.renderCircle();
  }

  renderApprovedIcon () {
    return (
      <div className='invoice-activity-status-step-circle approved'>
        <div className='invoice-activity-status-step-circle-icon'>
          <img src={require('images/icons/check.svg')} />
        </div>
      </div>
    );
  }

  renderDeniedIcon () {
    return (
      <div className='invoice-activity-status-step-circle denied'>
        <div className='invoice-activity-status-step-circle-icon'>
          <img src={require('images/icons/cross.svg')} />
        </div>
      </div>
    );
  }

  renderCircle () {
    return (<div className='invoice-activity-status-step-circle' />);
  }

  renderStatusText () {
    if (this.isAwaitingApproval()) {
      return 'WAIT_JUDGEMENT';
    }

    if (this.isApproved()) {
      return 'APPROVED';
    }

    if (this.isNotApproved()) {
      return 'NOT_APPROVED';
    }

    if (this.isWaitingForPayment()) {
      return 'APPROVED_WITH_RES';
    }

    return '';
  }

  renderStepText (step, i) {
    if (step.type === 'salary') {
      return this.renderCompleteStepText(step, 'SALARY_PAYMENT', i);
    }
    if (step.type === 'invoice') {
      return this.renderCompleteStepText(step, 'INVOICE_PAYMENT', i);
    }

    return this.renderCompleteStepText(step, this.renderStatusText(), i);
  }

  renderCompleteStepText (step, translate, i) {
    return (
      <div key={i} className='invoice-activity-status-text'>
        <p className='invoice-activity-status-text-title '>
          <Translate content={translate} />
        </p>
        {this.renderSubtitle(step)}
      </div>
    );
  }

  renderSubtitle (step) {
    if (step.type === 'salary') {
      if (step.complete) {
        return this.renderSubtitleText('PAID', step.complete);
      } else if (this.getSalaryPlannedPaymentAt()) {
        return this.renderSubtitleText('EXPECTED_TO', this.getSalaryPlannedPaymentAt());
      }
      return false;
    }

    if (step.type === 'invoice') {
      return step.complete
        ? this.renderSubtitleText('INVOICE_PAID', this.props.invoice.fullPaymentDateTime)
        : false;
    }

    return step.complete
      ? this.renderSubtitleText('ORDER_APPROVED', this.props.invoice.sent)
      : false;
  }

  renderSubtitleText (translate, date) {
    return (
      <p className='invoice-activity-status-text-subtitle'>
        <Translate content={translate} date={Utils.formatDate(date)} />
      </p>
    );
  }

  renderStep (step, i) {
    const lineStyle = step.complete ? 'green' : 'dotted';
    const stepClass = i === 0 ? ' first' : '';
    const line = i !== 0 ? <div className={'invoice-activity-status-step-line ' + lineStyle} /> : null;
    return (
      <div key={i} className={'invoice-activity-status-step' + stepClass}>
        {line}
        {this.renderStepIcon(step.complete, step.denied)}
      </div>
    );
  }

  render () {
    const steps = this.getSteps();
    const renderSteps = steps.map((step, i) => this.renderStep(step, i));
    const renderStepText = steps.map((step, i) => this.renderStepText(step, i));
    return (
      <div className='invoice-activity-status-container'>
        <div className={'invoice-activity-status-steps' + (this.props.containerStyle || '')}>
          {renderSteps}
        </div>
        <div className='invoice-activity-status-text-container'>
          {renderStepText}
        </div>
      </div>
    );
  }
}

export default InvoiceActivityStatus;



/** WEBPACK FOOTER **
 ** ./src/components/invoice-activity-status/invoice-activity-status.js
 **/